import MuiSkeleton from '@zenbusiness/zui/Skeleton';
import { styled } from '@zenbusiness/zui/styles';

const SkeletonStyles = () => ({
  borderRadius: '6px',
  transform: 'none'
});

export const SkeletonStyled = styled(MuiSkeleton)(SkeletonStyles);
